export default __webpack_public_path__ + "static/media/Edttt.3c5f2742.jpg";